module.exports = __webpack_public_path__ + "static/media/Vancouver.9b841b09.png";